export enum OcppDimmerState {
    OFF = '0',
    LOW = '10',
    MEDIUM = '50',
    HIGH = '100',
}
